<template>
  <!-- /.panel-heading -->
  <div class="panel-body deposit-options">
    <div class="panel-heading panel-heading-color">{{$t('deposit.credit_card_information')}}</div>
    <div class="row">
      <div class="col-md-offset-3 col-md-6 col-lg-offset-3 col-lg-6 col-xl-offset-3 col-xl-6">
        <div class="panel panel-default panel-choose">
          <div class="row ">
            <div v-if="validacion" class="card-info">
                <div class="alert alert-danger" role="alert">
                  <div v-html="$t('deposit.warnings.select_live_account')"></div>
                </div>
            </div>
            <div v-else>
              <div class="col-xs-12 col-sm-12 card-form">
                <div class="col-xs-12 col-sm-12 CardType">
                    <img v-bind:src="'https://raw.githubusercontent.com/muhammederdem/credit-card-form/master/src/assets/images/' + getCardType + '.png'" v-if="getCardType" class="card-item__typeImg">
                </div>
                <br>
                <div class="col-xs-12 col-sm-12 info">
                  <div class="col-xs-12 col-sm-12">
                    <label>{{$t('deposit.creditCard.numberCard')}}</label>
                    <label class="number">{{setCardNumber()}}</label>
                  </div>
                  <div class="col-xs-12 col-sm-9 nameCard">
                    <label>{{$t('deposit.creditCard.nameCard')}}</label>
                    <label>{{cardName}}</label>
                  </div>
                  <div class="col-xs-12 col-sm-3 dateCard">
                    <label>{{$t('deposit.creditCard.expires')}}</label>
                    <label> {{cardMonth}}/{{cardYear}} </label>
                  </div>
                </div>
              </div>

              <div class="col-xs-12 col-sm-12 card-info">
                <label>{{$t('deposit.amount')}}</label>
                <div style="padding-top:6px;"  class="col-xs-12 col-sm-6">
                  <input type="text" v-model="monto" class="form-control">
                </div>
                <div class="col-xs-12 col-sm-6 deposit-funds">
                  <button class="btn btn_mcv btn-primary col-xs-12 mrg-r-15 col-sm-3 mrg-b-25" @click="amount300()"><strong>300</strong></button>
                  <button class="btn btn_mcv btn-primary col-xs-12 mrg-r-15 col-sm-3 mrg-b-25" @click="amount500()"><strong>500</strong></button>
                  <button class="btn btn_mcv btn-primary col-xs-12 mrg-r-15 col-sm-3" @click="amount1000()"><strong>1000</strong></button>
                </div>
              </div>

              <div class="col-xs-12 col-sm-12 card-info">
                <div class="space-30"></div>
                <hr>
                <div class="space-30"></div>
                <div class="col-xs-12 col-sm-8" >
                <label>{{$t('deposit.creditCard.numberCard')}}</label>
                  <input 
                    type="text" 
                    id="numberCard" 
                    class="form-control" 
                    v-mask="generateCardNumberMask" 
                    v-model="cardNumberForm" 
                    data-ref="numberCard" 
                    autocomplete="off"
                    placeholder="0000 0000 0000 0000"
                    @focus="$event.target.select()"
                  >
                </div>
                <div class="col-xs-12 col-sm-4">
                  <label>{{$t('deposit.creditCard.cvvCard')}}</label>
                  <input
                    type="password"
                    v-model="cardCvv"
                    class="form-control cardCvv"
                    @focus="$event.target.select()"
                    placeholder="xxxx"
                  >
                </div>
                <div class="space-30"></div>
                <div class="col-xs-12 col-sm-8">
                  <label>{{$t('deposit.creditCard.nameCard')}}</label>
                  <input
                    type="text"
                    v-model="cardName"
                    class="form-control"
                  >
                </div>
                <div class="col-xs-12 col-sm-4">
                  <label>{{$t('deposit.creditCard.dateCard')}}</label>
                </div>
                <div class="col-xs-12 col-sm-2">
              <select class="form-control" id="monthCard" v-model="cardMonth"  data-ref="monthCard">
                  <option value="MM" disabled selected>{{$t('deposit.creditCard.month')}}</option>
                  <option v-bind:value="n < 10 ? '0' + n : n" v-for="n in 12" v-bind:disabled="n < minCardMonth" v-bind:key="n">
                      {{n < 10 ? '0' + n : n}}
                  </option>
              </select>
              </div>
              <div class="col-xs-12 col-sm-2">
                <select class="form-control" id="yearCard" v-model="cardYear"  data-ref="yearCard">
                  <option value="YYYY" disabled selected>{{$t('deposit.creditCard.year')}}</option>
                  <option v-bind:value="$index + minCardYear" v-for="(n, $index) in 12" v-bind:key="n">
                      {{$index + minCardYear}}
                  </option>
                </select>
              </div>
              <div class="space-30"></div>
              <hr>
              <div class="space-30"></div>
              <div class="col-xs-12 col-sm-12">
                  <label>{{$t('profile.address')}}</label>
                  <input
                    type="text"
                    v-model="address"
                    class="form-control"
                  >
                </div>
                <div class="col-xs-12 col-sm-4">
                  <label>{{$t('profile.state')}}</label>
                  <input
                    type="text"
                    v-model="state"
                    class="form-control"
                  >
                </div>
                <div class="col-xs-12 col-sm-4">
                  <label>{{$t('profile.city')}}</label>
                  <input
                    type="text"
                    v-model="city"
                    class="form-control"
                  >
                </div>
                <div class="col-xs-12 col-sm-4">
                  <label>{{$t('profile.country')}}</label>
                  <input
                    type="text"
                    v-model="country"
                    class="form-control"
                    :disabled="true"
                  >
                </div>
              <div class="space-30"></div>
                <br>
                <center>
                  <button
                      type="button"
                      v-on:click="goToStep('payment')"
                      class="btn btn-default mrg-b-25"
                    >{{$t('shared.buttons.prev')}}
                  </button>
                  <button
                      type="button"
                      v-on:click="enviarDatos()"
                      class="btn btn-primary mrg-r-15 mrg-b-25 v-button"
                    >{{$t('shared.buttons.next')}}
                  </button>
                </center>
              </div>
              <div class="space-30"></div>
              </div>
            </div>
          </div>
        </div>
        <!-- /.panel-body -->
      </div>
    </div>
  

  </div>
</template>

<script>
import ProfileService from '@/services/ProfileService';
import AccountService from "@/services/AccountService";
import EventBus from "@/event-bus";
import { required } from "vuelidate/lib/validators";

const isDecimal = value => /^\d+(\.\d{1,2})?$/.test(value);
const isValidAmount = value => value > 0 && isDecimal;

let srv = new ProfileService();
let accountService = new AccountService();
// let cardService = new CardService();

export default {
  name: "infoCreditCard",

  props:{
    "numberCard":{
      type: String,
      default:""
    },
    "nameCard":{
      type: String,
      default:""
    },
    "cvvCard":{
      type: String,
      default:""
    },
    "monthCard":{
      type: String,
      default:"MM"
    },
    "yearCard":{
      type: String,
      default:"YYYY"
    },
    "options":{
      type: String,
      default:""
    },
    "amounts":{
      type: String,
      default:""
    },
  },
  
  data() {
    return {
      cardName: "",
      cardNumberForm: "",
      cardNumber: "XXXX XXXX XXXX XXXX",
      cardMonth: "MM",
      cardYear: "YYYY",
      cardCvv: "",
      minCardYear: new Date().getFullYear(),
      amexCardMask: "#### ###### #####",
      otherCardMask: "#### #### #### ####",
      cardNumberTemp: "",
      isCardFlipped: false,
      focusElementStyle: null,
      isInputFocused: false,
      mT4Account: {},
      monto: 0,
      login:"",
      validacion:this.validarTipoDeCuenta(),
      firstName:"",
      lastName:"",
      fullName:"",
      email:"",
      address:"",
      city:"",
      state:"",
      country:""
    };
  },
  
  computed:{
    getCardType () {
      let number = this.numberCard;
      let re = new RegExp("^4");
      if (number.match(re) != null) return "visa";

      re = new RegExp("^(34|37)");
      if (number.match(re) != null) return "amex";

      re = new RegExp("^5[1-5]");
      if (number.match(re) != null) return "mastercard";

      re = new RegExp("^6011");
      if (number.match(re) != null) return "discover";
      
      re = new RegExp('^9792')
      if (number.match(re) != null) return 'troy'

      return "visa"; // default type
    },
    generateCardNumberMask () {
			return this.getCardType === "amex" ? this.amexCardMask : this.otherCardMask;
    },
    minCardMonth () {
      if (this.cardYear === this.minCardYear) return new Date().getMonth() + 1;
      return 1;
    }
  },

  methods: {
    validarTipoDeCuenta:function(){
      accountService.getDefaultMt4Account().then((r) => {
        this.mT4Account = r.data.accountType.mT4Server;
        console.log(r);
        this.login = r.data.login;
        this.validacion = this.mT4Account.isDemo;
        });
    },

    setCardNumber:function(){
        // return this.cardNumber
        if (this.cardNumberForm == ""){
          return "XXXX XXXX XXXX XXXX"
        } else {
          return this.cardNumber = this.cardNumberForm;
        }
    },
    enviarDatos(){
      let model = {
        account:{
          mt4_live: this.login,
          name: this.fullName,
          lastName: this.lastName,
          firstName: this.firstName,
          email: this.email,
          address: this.address,
          city: this.city,
          state: this.state,
          country: this.country,
        },
        card:{
          name: this.cardName,
          number: this.cardNumberForm,
          cvv: this.cardCvv,
          date:{
            month: this.cardMonth,
            year: this.cardYear
          },
          amount:this.monto,
        }
      };

      console.log("antes de enviar los datos");
      console.log(model);

      // let url = "";
      // let text = {}

      // let post = {
      //   method: "POST",
      //   body: JSON.stringify(text),
      //   headers:{
      //     "Content-Type": "application/json"
      //   },
      // };

      // fetch(url,post).then((res) => res.json());
      fetch("https://pokeapi.co/api/v2/pokemon/pikachu")
      .then((res) => res.json())
      .then((data)=>(console.log(data)));


    },
    amount300(){
      this.monto = 300;
    },
    amount500(){
      this.monto = 500;
    },
    amount1000(){
      this.monto = 1000;
    },
    setAmount(amount) {
      this.$props.options.amount = amount;
    },
    setNumberCard(numberCard) {
      this.$props.numberCard = numberCard;
    },
    goToStep(step) {
      EventBus.$emit("onGoToStep", step);
    }
  },

  created() {
    EventBus.$on('onUpdateDefaultMt4Account', account =>{
        this.validacion = account.accountType.mT4Server.isDemo;
    });
  },

  beforeUpdate(){
    srv.get().then((r) => {
      console.log("otros datos");
      console.log(r);
      this.firstName = r.data.firstName;
      this.lastName = r.data.lastName;
      this.fullName = this.firstName + " " + this.lastName;
      this.email = r.data.email;
      this.address = r.data.street;
      this.city = r.data.city;
      this.state = r.data.state;
      this.country = r.data.country.text;
      });
  },

  validations: {
    options: {
      pSPConfig: {
        required
      },
      amount: {
        required,
        numberValid: isDecimal,
        isValidAmount
      }
    }
  }
};
</script>

<style>
  @import url("https://fonts.googleapis.com/css?family=Source+Code+Pro:400,500,600,700|Source+Sans+Pro:400,600,700&display=swap");
  .btn{
      margin-right: 20px;

  }
  .btn_mcv{
    	background: #fff;
      color: #0F5476;
      border: none;
      box-shadow: 1px 1px 30px 0px rgb(195, 195, 195);
      text-align: center;
      margin-right: 20px;
      padding: 2px 2px 2px 2px;
  }
  .card-form{
    background: #0F5476;
    width: 500px;
    height: 300px;
    margin: 0px 225px 125px 225px;
    box-shadow: 5px 5px 25px 5px;
    border-radius: 25px;
  }
  .card-form .info{
    padding-top: 45px;
    margin-bottom: 0%;
  }
  .card-form .info .number{
    font-size: 25pt;
    height: 25pt;
    padding-bottom: 40px;
  }
  .card-form label{
    color: #fff;
  }
  .card-info select{
    min-width: 95px;
  }
  .card-form .CardType{
    margin: 25px 20px 25px 5px;
  }
  .card-form .CardType img{
    max-width: 100px;
    max-height: 55px;
  }

  @media (max-width: 991px) {
    .card-form{
      width: 400px;
      height: 250px;
      margin: 25px 0px 50px 400px;
      box-shadow: 5px 5px 25px 5px;
      border-radius: 25px;
    }
    .card-info, .card-monto{
      margin: 25px 0px 50px 300px;
      max-width: 600px;
    }
    .card-form .info .number{
      font-size: 20pt;
      height: 15pt;
      padding-bottom: 30px;
    }
    .card-form .CardType img{
      max-width: 100px;
      max-height: 50px;
    }
    .card-form .CardType{
      margin: 25px 0px 0px 5px;
    }
    .card-form .info{
      padding-top: 20px;
    }
    .nameCard {
      width: 260px;
    }
    .dateCard {
      width: 30px;
      font-size: 12pt !important;
    }
  }

  @media (max-width: 750px) {
    .deposit-funds{
      margin-top: 20px ;
    }
    .card-form{
      width: 400px;
      height: 250px;
      margin: 75px 0px 50px 15px;
      box-shadow: 5px 5px 25px 5px;
      border-radius: 25px;
    }
    .card-info{
      margin: 25px 0px 50px 0px;
    }
    .card-form .info .number{
      font-size: 20pt;
      height: 15pt;
      padding-bottom: 30px;
    }
    .card-form .CardType img{
      max-width: 100px;
      max-height: 50px;
    }
    .card-form .CardType{
      margin: 25px 0px 0px 0px;
    }
    .card-form .info{
      padding-top: 20px;
    }
    .nameCard {
      width: 260px;
    }
    .dateCard {
      width: 30px;
      font-size: 12pt !important;
    }
  }
  
</style>


// WEBPACK FOOTER //
// src/components/credit_card_info.vue